import type { RoleTypeOperationTypeDto } from "common/models/api/models/RoleTypeOperationTypeDto";
import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import { Queries } from "ui/query/queries";
import { releaseStrategyApi } from "../api/releaseStrategyApi";

export default function useGetOperationTypes({
    enabled = true,
    ...options
}: UseQueryOptions<
    RoleTypeOperationTypeDto[],
    unknown,
    RoleTypeOperationTypeDto[],
    Queries.RELEASE_STRATEGY_OPERATIONS
> = {}): UseQueryResult<RoleTypeOperationTypeDto[]> {
    return useQuery(
        Queries.RELEASE_STRATEGY_OPERATIONS,
        async () => {
            const res = await releaseStrategyApi.findAllOperationTypes();
            return res.data;
        },
        { ...options, enabled },
    );
}
